import { Injectable, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  onYesNoRequested$ = new Subject<any>();

  openModal: any;

  constructor(private modals : NgbModal) { }

  showModal(modal : ElementRef, size : string) {
    if (this.openModal) this.openModal.close();    
    var sizeToUse = null;
    if (size == "sm") sizeToUse = "sm";
    if (size == "lg") sizeToUse = "lg";
    this.openModal = this.modals.open(modal, { size: sizeToUse, centered: true});
    return this.openModal;
  }

  yesNo(title, message, onYes, onNo)
  {
    var args = {
      title: title,
      message : message,
      onYes : onYes,
      onNo : onNo
    };

    this.onYesNoRequested$.next(args);
  }
}
